import Guard from '../../services/Middleware'

export default [
  {
    path: '/Funcionarios/Motoristas',
    name:'Gestão de Motoristas',
    component: () => import('@/views/funcionarios/motoristas/index.vue'),
    beforeEnter: Guard.auth
  },
  {
    path: '/Funcionarios/Motoristas/add',
    name:'Adicionar Motorista',
    component: () => import('@/views/funcionarios/motoristas/add.vue'),
    beforeEnter: Guard.auth
  },
  {
    path: '/Funcionarios/Motoristas/add/:id',
    name:'Editar Motorista',
    component: () => import('@/views/funcionarios/motoristas/add.vue'),
    beforeEnter: Guard.auth
  },
  {
    path: '/Funcionarios/Motoristas/Diario-de-bordo',
    name:'Diário de Bordo Motorista',
    component: () => import('@/views/cargas/DiarioBordo.vue'),
    beforeEnter: Guard.auth
  },
  {
    path: '/Funcionarios/Motoristas/Diario-de-bordo/:id',
    name:'Diário de Bordo Motorista Detalhe',
    component: () => import('@/views/cargas/DiarioBordoDetalhe.vue'),
    beforeEnter: Guard.auth
  }
  
]